import moment from "moment";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { DivTickets } from "../StudentManagement/styles";
import PlaceholderText from "../../components/Placeholder/PlaceholderText";
import { getFilterTickets, getTicketsTeachers } from "../../store/middleware";

function TabTickets({ id }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { ticketsTeachers } = useSelector((state) => state.companyManagerReducer);

  const getData = async () => await dispatch(getTicketsTeachers(id));

  const handleTicketDetail = (id) => {
    dispatch(
      getFilterTickets({
        id,
        requester: "",
        role: "",
        ticketTypeId: "",
        ticketSubTypeId: "",
        createdAt: "",
        status: "",
        pageNumber: 1,
        pageSize: 10,
      }),
    );
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <DivTickets>
      <div className="boxContainerTickets">
        <div className="tab-content">
          {!ticketsTeachers?.length ? (
            <PlaceholderText label="No results" />
          ) : (
            ticketsTeachers?.map((ticket) => (
              <div key={ticket.id} className="boxRow">
                <div className="item">
                  <div className="boxColumn">
                    <label>{t("TICKET_ID")}</label>
                    <span>{ticket.id}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("STATUS")}</label>
                    <span className={ticket.active ? "active" : "deactive"}>
                      {ticket.active ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("TITLE")}</label>
                    <span>{ticket.title}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("TYPE")}</label>
                    <span>{ticket.ticketType ? ticket.ticketType.nameEnglish : ""}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("SUBTYPE")}</label>
                    <span>{ticket.ticketSubType ? ticket.ticketSubType.nameEnglish : ""}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>{t("OPEN_DATE")}</label>
                    <span>{moment(ticket.createdAt).format("YYYY/MM/DD • hh:mm")}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <label>Last Interaction</label>
                    <span>{moment(ticket.updatedAt).format("YYYY/MM/DD • hh:mm")}</span>
                  </div>
                </div>

                <div className="item">
                  <div className="boxColumn">
                    <div className="status">
                      <Link to={"/customer-service/ticketDetail"} state={{ from: "ticketTeacher" }}>
                        <button onClick={() => handleTicketDetail(ticket.id)}>
                          {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true"></i>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </DivTickets>
  );
}

export default TabTickets;
